export default {
  namespaced: true,
  state: {
    showH5Footer: false,
  },
  mutations: {
    setShowH5Footer(state, val) {
      console.log(3333, val);

      state.showH5Footer = val;
    },
  },
  actions: {},
};
